import { faWarning } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/design-system/Icon";

type Props = {
  type: string;
  statusCode: string;
};

export const StatusColumn: React.FC<Props> = ({ type, statusCode }) => {
  if (type === "successful") {
    return <span className="capitalize">Successful</span>;
  }
  return (
    <div className="flex items-center">
      <Icon icon={faWarning} size="xs" variant="error" />
      <span className="ml-1.5 min-w-0 flex-1 whitespace-nowrap">
        Failed: Status code {statusCode}
      </span>
    </div>
  );
};
